export enum AttributeDataType {
  FOREIGN_KEY = 0,
  TEXT = 1,
  INT = 2,
  FRACTION = 3,
  DATETIME = 4,
  BOOLEAN = 5,
}

export enum FilterOperator {
  IS = 0,
  IS_NOT = 1,
  IS_EMPTY = 2,
  CONTAINS = 3,
  STARTS_WITH = 4,
  ENDS_WITH = 5,
  RANGE = 6,
}

export interface DynamicFilter {
  filterBy: string;
  type: string;
  value: any; // Can be string or {from: string, to: string} for range
}

export interface DateRangeValue {
  from: string;
  to: string;
}
